import React from 'react'
import { Helmet } from 'react-helmet'
import LockIcon from '../../asset/lock.svg'
import LoadingPage from '../../components/LoadingPageCard'
import { LoadingPageContainer } from '../../components/PageWrapper/styles'

const ProcessCancelling = () => {
  const LoadingPageData = {
    centerIcon: LockIcon,
    title: 'No data has been shared',
    subtitle: 'We will now take you back to CompareBanks.',
    redirectPath: '/',
  }

  return (
    <LoadingPageContainer>
      <Helmet>
        <title>Loading</title>
        <link rel="icon" href="./asset/bankIcon.svg" />
      </Helmet>
      <LoadingPage {...LoadingPageData} />
    </LoadingPageContainer>
  )
}

export default ProcessCancelling
